import {ShopSection} from './shop-section.model';
import {ShopCSP} from './shop-csp.model';

export type ShopHeader = 'none' | 'poster' | 'background' | 'color';

export enum ShopType {
  DEFAULT = 'default',
  CUSTOM = 'custom'
}

export enum ShopTheme {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface ShopLanguage {
  language_id: number;
  title: string;
  description: string;
  end_of_sale: string;
}

export interface ShopLayout {
  backgroundUrl: string | null;
  posterUrl: string | null;
  headerType: ShopHeader;
  language: ShopLanguage;
  languages: ShopLanguage[];
  sections: ShopSection[];
  color: string;
  theme: ShopTheme;
}

export interface ShopAdvancedOptions {
  isPortalLogoHidden: boolean;
  isOnlyPurchaseTunnel: boolean;
}

export interface ShopDeveloperOptions {
  customHtml: string;
  customCss: string;
  csps: ShopCSP[];
}

export type ShopConfig = ShopLayout & ShopAdvancedOptions & ShopDeveloperOptions;

export interface Shop {
  name: string;
  code: string;
  type: ShopType;
  header: ShopHeader;
  poster_url: string;
  background_url: string;
  thumbnail_url: string;
  is_portal_logo_hidden: boolean;
  is_only_purchase_tunnel: boolean;
  color: string;
  theme: string;
  integration_link: string;
  event_count: number;
  start_date: number;
  end_date: number;
  custom_html: string;
  custom_css: string;
  updated_at: number;
  language?: ShopLanguage;
  languages?: ShopLanguage[];
  sections?: ShopSection[];
  csps?: ShopCSP[];
}
